import styled from 'styled-components';
import { DatePicker } from '@perch-labs/shrike';

export const StyledDatePicker = styled(DatePicker)`
  text-align: center;

  label {
    margin-right: auto;
    margin-left: auto;
  }

  &&& {
    [class*='__day'] {
      margin: 4px 8px;
      font-size: ${props => props.theme.fontSizes[300]};

      ${props => props.theme.media.xsmall`
        margin: 2px;
      `}
    }

    [aria-disabled='false'] {
      padding-bottom: 1px;
      border-radius: 50%;
      background-color: ${props => props.theme.colors.background.secondary};
    }

    [class*='--selected'] {
      background-color: ${props =>
        props.theme.colors.background.primaryInverse};
    }
  }
`;
